export var EPaymentStatus;
(function (EPaymentStatus) {
    EPaymentStatus["UNINITIALIZED"] = "UNINITIALIZED";
    EPaymentStatus["PROCESSING"] = "PROCESSING";
    EPaymentStatus["PAID"] = "PAID";
    EPaymentStatus["FAILED"] = "FAILED";
    EPaymentStatus["PRINTING_RECEIPT"] = "PRINTING_RECEIPT";
    EPaymentStatus["PRINTING_RECEIPT_SUCCESS"] = "PRINTING_RECEIPT_SUCCESS";
    EPaymentStatus["SENDING_RECEIPT"] = "SENDING_RECEIPT";
    EPaymentStatus["SENDING_RECEIPT_SUCCESS"] = "SENDING_RECEIPT_SUCCESS";
    EPaymentStatus["ERROR"] = "ERROR";
})(EPaymentStatus || (EPaymentStatus = {}));
